"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { TextParagraph, Accordion, TextParagraphBold, UnorderedList, AccordionItem } from "@ops-gsic/cxp-component-library-react";
export default function ExpanderInfoSection() {
  const $ = _c(127);
  const t = useTranslations("HomePage");
  let t0;
  if ($[0] !== t) {
    t0 = t("information.reasonFor.heading");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("information.reasonFor.section1.heading");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <TextParagraphBold>{t1}</TextParagraphBold>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("information.reasonFor.section1.ln");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <TextParagraph>{t3}</TextParagraph>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("information.reasonFor.section1.ln1");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <li>{t5}</li>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("information.reasonFor.section1.ln2");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <li>{t7}</li>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("information.reasonFor.section1.ln3");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <li>{t9}</li>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6 || $[24] !== t8) {
    t11 = <UnorderedList>{t6}{t8}{t10}</UnorderedList>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("information.reasonFor.section2.heading");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12) {
    t13 = <TextParagraphBold>{t12}</TextParagraphBold>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("information.reasonFor.section2.ln");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <TextParagraph>{t14}</TextParagraph>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("information.reasonFor.section2.ln1");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <li>{t16}</li>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("information.reasonFor.section2.ln2");
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t18) {
    t19 = <li>{t18}</li>;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = t("information.reasonFor.section2.ln3");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t20) {
    t21 = <li>{t20}</li>;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t) {
    t22 = t("information.reasonFor.section2.ln4");
    $[46] = t;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t22) {
    t23 = <li>{t22}</li>;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t17 || $[51] !== t19 || $[52] !== t21 || $[53] !== t23) {
    t24 = <UnorderedList>{t17}{t19}{t21}{t23}</UnorderedList>;
    $[50] = t17;
    $[51] = t19;
    $[52] = t21;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t11 || $[56] !== t13 || $[57] !== t15 || $[58] !== t2 || $[59] !== t24 || $[60] !== t4) {
    t25 = <>{t2}{t4}{t11}{t13}{t15}{t24}</>;
    $[55] = t11;
    $[56] = t13;
    $[57] = t15;
    $[58] = t2;
    $[59] = t24;
    $[60] = t4;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t0 || $[63] !== t25) {
    t26 = {
      name: "reasonFor",
      title: t0,
      content: t25
    };
    $[62] = t0;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t) {
    t27 = t("information.deliveryOf.heading");
    $[65] = t;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t) {
    t28 = t("information.deliveryOf.line1");
    $[67] = t;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== t28) {
    t29 = <li>{t28}</li>;
    $[69] = t28;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t) {
    t30 = t("information.deliveryOf.line2");
    $[71] = t;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  let t31;
  if ($[73] !== t30) {
    t31 = <li>{t30}</li>;
    $[73] = t30;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== t) {
    t32 = t("information.deliveryOf.line3");
    $[75] = t;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  let t33;
  if ($[77] !== t32) {
    t33 = <li>{t32}</li>;
    $[77] = t32;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== t29 || $[80] !== t31 || $[81] !== t33) {
    t34 = <><UnorderedList>{t29}{t31}{t33}</UnorderedList></>;
    $[79] = t29;
    $[80] = t31;
    $[81] = t33;
    $[82] = t34;
  } else {
    t34 = $[82];
  }
  let t35;
  if ($[83] !== t27 || $[84] !== t34) {
    t35 = {
      name: "deliveryOf",
      title: t27,
      content: t34
    };
    $[83] = t27;
    $[84] = t34;
    $[85] = t35;
  } else {
    t35 = $[85];
  }
  let t36;
  if ($[86] !== t) {
    t36 = t("information.collectionOfPersonal.heading");
    $[86] = t;
    $[87] = t36;
  } else {
    t36 = $[87];
  }
  let t37;
  if ($[88] !== t) {
    t37 = t.rich("information.collectionOfPersonal.line.text", {
      link2: chunks => <a href={t("information.collectionOfPersonal.line.url2")} target="_blank" rel="noopener noreferrer">{chunks}</a>
    });
    $[88] = t;
    $[89] = t37;
  } else {
    t37 = $[89];
  }
  let t38;
  if ($[90] !== t37) {
    t38 = <><TextParagraph>{t37}</TextParagraph></>;
    $[90] = t37;
    $[91] = t38;
  } else {
    t38 = $[91];
  }
  let t39;
  if ($[92] !== t36 || $[93] !== t38) {
    t39 = {
      name: "collectionOfPersonalInformation",
      title: t36,
      content: t38
    };
    $[92] = t36;
    $[93] = t38;
    $[94] = t39;
  } else {
    t39 = $[94];
  }
  let t40;
  if ($[95] !== t) {
    t40 = t("information.privacyStatement.heading");
    $[95] = t;
    $[96] = t40;
  } else {
    t40 = $[96];
  }
  let t41;
  if ($[97] !== t) {
    t41 = t.rich("information.privacyStatement.line.text", {
      link: chunks_0 => <a href={t("information.privacyStatement.line.url")} target="_blank" rel="noopener noreferrer">{chunks_0}</a>
    });
    $[97] = t;
    $[98] = t41;
  } else {
    t41 = $[98];
  }
  let t42;
  if ($[99] !== t41) {
    t42 = <><TextParagraph>{t41}</TextParagraph></>;
    $[99] = t41;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] !== t40 || $[102] !== t42) {
    t43 = {
      name: "privacyStatement",
      title: t40,
      content: t42
    };
    $[101] = t40;
    $[102] = t42;
    $[103] = t43;
  } else {
    t43 = $[103];
  }
  let t44;
  if ($[104] !== t) {
    t44 = t("information.browser.heading");
    $[104] = t;
    $[105] = t44;
  } else {
    t44 = $[105];
  }
  let t45;
  if ($[106] !== t) {
    t45 = t.rich("information.browser.line.text", {
      link: chunks_1 => <a href={t("information.browser.line.url")} target="_blank" rel="noopener noreferrer">{chunks_1}</a>
    });
    $[106] = t;
    $[107] = t45;
  } else {
    t45 = $[107];
  }
  let t46;
  if ($[108] !== t45) {
    t46 = <><TextParagraph>{t45}</TextParagraph></>;
    $[108] = t45;
    $[109] = t46;
  } else {
    t46 = $[109];
  }
  let t47;
  if ($[110] !== t44 || $[111] !== t46) {
    t47 = {
      name: "browser",
      title: t44,
      content: t46
    };
    $[110] = t44;
    $[111] = t46;
    $[112] = t47;
  } else {
    t47 = $[112];
  }
  let t48;
  if ($[113] !== t26 || $[114] !== t35 || $[115] !== t39 || $[116] !== t43 || $[117] !== t47) {
    t48 = [t26, t35, t39, t43, t47];
    $[113] = t26;
    $[114] = t35;
    $[115] = t39;
    $[116] = t43;
    $[117] = t47;
    $[118] = t48;
  } else {
    t48 = $[118];
  }
  const items = t48;
  let t49;
  if ($[119] !== t) {
    t49 = t("accordion.expandAll");
    $[119] = t;
    $[120] = t49;
  } else {
    t49 = $[120];
  }
  let t50;
  if ($[121] !== t) {
    t50 = t("accordion.collapseAll");
    $[121] = t;
    $[122] = t50;
  } else {
    t50 = $[122];
  }
  let t51;
  if ($[123] !== items || $[124] !== t49 || $[125] !== t50) {
    t51 = <Accordion showExpandAll={true} expandAllText={t49} collapseAllText={t50} items={items} />;
    $[123] = items;
    $[124] = t49;
    $[125] = t50;
    $[126] = t51;
  } else {
    t51 = $[126];
  }
  return t51;
}